import { Component, computed, inject, input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco'; // cspell:disable-line
import { LucideAngularModule } from 'lucide-angular';
import { TipSection } from '../../../models/reduction-tip';
import { ReductionTipsService } from '../../../services/reduction-tips.service';
import { ReductionTipItemComponent } from '../reduction-tip-item/reduction-tip-item.component';
import { TIP_SECTION_LABEL_KEY } from '../../../constants/reduction-tip-sections';

/**
 * The tips of one stats category, in a card of their own under the category's
 * results — outside the collapsible frame, so they stay in view when the
 * results are folded. The card folds on its own, down to its header.
 */
@Component({
  selector: 'app-reduction-tips-card',
  standalone: true,
  imports: [TranslocoModule, LucideAngularModule, ReductionTipItemComponent],
  templateUrl: './reduction-tips-card.component.html',
})
export class ReductionTipsCardComponent {
  section = input.required<TipSection>();

  private tipsService = inject(ReductionTipsService);

  tips = computed(() => this.tipsService.tipsBySection()[this.section()] ?? []);
  labelKey = computed(() => TIP_SECTION_LABEL_KEY[this.section()]);

  open = computed(() => this.tipsService.openTipSections().has(this.section()));

  toggle(): void {
    this.tipsService.toggleTipSection(this.section());
  }
}
